<template>
  <div>
    <h3 class="heading-3 mt-5 text-left text-shadow text-xl font-bold leading-none">All Skins</h3>

    <!-- Skin Page results -->
    <ais-instant-search
      :search-client="searchClient"
      index-name="skin_pages_by_price_asc"
    >
      <div class="flex flex-wrap-reverse lg:-ml-4 mt-6 md:flex-wrap gap-6 justify-between">
        <!-- Text search -->
        <text-filter
          v-model="query"
          :clear-on-empty="false"
          :debounced="false"
        />
        <ais-configure :query="query" />

        <!-- Price search -->
        <algolia-refinement-list-dropdown
          attribute="price"
          name="Price"
          :side="side"
        />

        <algolia-checkbox
          attribute="legacy"
          label="Legacy Skins"
        />

        <!-- Sort -->
        <div class="flex-1 flex justify-end">
          <algolia-sort
            :items="[
              { value:'skin_pages_by_price_asc', label: 'Price (ASC)' },
              { value:'skin_pages_by_price_desc', label: 'Price (DESC)' },
              { value:'skin_pages_by_release_date_asc', label: 'Release Date (ASC)' },
              { value:'skin_pages_by_release_date_desc', label: 'Release Date (DESC)' },
              { value:'skin_pages_by_rarity_asc', label: 'Rarity (ASC)' },
              { value:'skin_pages_by_rarity_desc', label: 'Rarity (DESC)' },
            ]"
          />
        </div>
      </div>
      <div class="flex justify-end mt-6">
        <ais-clear-refinements>
          <div
            slot-scope="{ refine }"
            @click.prevent="refine"
            class="cursor-pointer"
          >
            Clear
          </div>
        </ais-clear-refinements>
      </div>

      <portal-target name="champions_search" />

      <h3 class="text-xl font-bold leading-none heading-3 mt-5 text-center lg:text-left text-shadow"
        v-if="query.length > 0"
      >
        Skins
      </h3>

      <ais-hits :transform-items="transformSkinItems">
        <div
          slot-scope="{ items }"
          class="flex flex-wrap mt-8 justify-center"
          style="margin-left: -20px"
        >
          <skindex-skin-card
            v-for="item in items"
            :key="item.slug"
            :skin-page="item"
          />
        </div>
      </ais-hits>

      <algolia-pagination />
    </ais-instant-search>

    <!-- Champions results -->
    <portal to="champions_search">
      <ais-instant-search
        :search-client="searchClient"
        index-name="champions"
      >
        <!--
          We don't limit the number of items returned when the user is not
          searching, so that all items are rendered in the page. Once the user
          starts searching, we only show a certain amount of items.
        -->
        <ais-configure :query="query" :hitsPerPage="query.length > 0 ? 5 : 9999" />

        <div>
          <ais-hits :transform-items="transformChampionItems">
            <div slot-scope="{ items }">
              <!--
                Only display the champions results when the user is actively
                searching for something, and when there are actual results.
                When the use is not searching, the results are not visible, but
                are still rendered in the page for SEO purposes.
              -->
              <div v-show="query.length > 0 && items.length > 0">
                <h3 class="heading-3 mt-5 text-center lg:text-left text-shadow text-xl font-bold leading-none">
                  Champions
                </h3>

                <div
                  class="flex flex-wrap mt-8"
                  style="margin-left: -20px"
                >
                  <skindex-champion-card
                    v-for="item in items"
                    :key="item.slug"
                    :champion="item"
                  />
                </div>
              </div>
            </div>
          </ais-hits>
        </div>
      </ais-instant-search>
    </portal>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';

import SkindexSkinCard from './SkindexSkinCard';
import SkindexChampionCard from './SkindexChampionCard';
import TextFilter from '../filters/TextFilter';
import AlgoliaRefinementListDropdown from './AlgoliaRefinementListDropdown';
import AlgoliaSort from './AlgoliaSort';
import AlgoliaCheckbox from './AlgoliaCheckbox';
import AlgoliaPagination from './AlgoliaPagination';

export default {
  components: {
    'algolia-checkbox': AlgoliaCheckbox,
    'algolia-refinement-list-dropdown': AlgoliaRefinementListDropdown,
    'algolia-sort': AlgoliaSort,
    'algolia-pagination': AlgoliaPagination,
    'text-filter': TextFilter,
    'skindex-champion-card': SkindexChampionCard,
    'skindex-skin-card': SkindexSkinCard,
  },

  data() {
    return {
      searchClient: algoliasearch(
        process.env.MIX_ALGOLIA_APP_ID,
        process.env.MIX_ALGOLIA_PUBLIC_KEY
      ),
      query: '',
    };
  },

  methods: {
    transformChampionItems(items) {
      return items;
    },

    transformSkinItems(items) {
      return items.map(item => {
        const releasedAt = new Date(item.released_at * 1000);
        let date = releasedAt.getDate();
        let month = releasedAt.getMonth() + 1;
        const year = releasedAt.getFullYear();

        date = date < 10 ? '0' + date : date;
        month = month < 10 ? '0' + month : month;

        return {
          ...item,
          released_at: `${date}/${month}/${year}`,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
